module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f015-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cn"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _c('br'), _vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "cit"
  }, [_c('span', {
    staticClass: "first-line"
  }, [_c('em', [_vm._v("For a moment none of them moved,")])]), _vm._v(" not even to breathe. Oates held Umber suspended in the air. The giant’s single eye gleamed, catching the yellow glow of the lanterns. "), _c('em', [_vm._v("How big is that eye?")]), _vm._v(" Hap asked himself, and then answered: "), _c('em', [_vm._v("As big as my head")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Get below, all of you,” Nima whispered. “Softly now. Take the lamps. Seal the hatch.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oates lowered Umber to the deck and released him. Umber didn’t struggle or try to climb over the railing again, but the angry expression hadn’t left his face. He backed toward the open hatch, still watching the sea-giant.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Hap’s legs quaked as he made his way to the stairs. A tear ran from the corner of Sophie’s eye, and sweat beaded Balfour’s ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("brow. Hap wasn’t sure that Bulrock was truly awake—not yet, anyway. The eye didn’t turn to follow them, and it never blinked. It simply gleamed, as vacantly as the moon. "), _c('em', [_vm._v("Don’t wake up,")]), _vm._v(" Hap said inwardly, over and over again, as if repeating the words would cast a spell.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("They descended the stairs to the lower deck. Umber stopped to look back one more time, until Oates seized him by the back of the collar and pulled him down. Nima had run onto Boroon’s back to tell him to dive, and she would cling to the leviathan’s back when he submerged.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oates closed the hatch, and a moment later the barge tilted. Hap heard water hiss up the sides and a dull roar as the sea engulfed the top deck. The vessel turned and surged forward before rising again, outside the vast cave, into the light of day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Umber sat on the bottom step. He scowled and hammered his knees with his fists, darting angry glares at the rest of them. When he heard water rushing off the barge, he threw the hatch open again and raced out, leaning far over the rear rail and staring at the cliff. The others followed, and Hap watched, praying that the giants would not suddenly rise up and wade after them in pursuit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They must still be asleep,” Balfour said at last, letting out a long breath. “Thank the stars for that.” He pulled a white handkerchief from his pocket and dabbed his brow.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Umber slapped the railing and whirled to confront the others. “What was "), _c('em', [_vm._v("that")]), _vm._v(" all about? How dare you restrain me, after all I’ve done for the lot of you!”")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Hap dropped his gaze, unable to meet Umber’s fiery stare.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Umber … what you tried to do … It was …,” Balfour began, before his voice trailed off.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It was "), _c('em', [_vm._v("what")]), _vm._v("?” cried Umber. “Out with it, Balfour! What, do you think I’m dangerous? Do you think I’m mad?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Balfour’s jaw worked up and down, until words finally eked out. “Umber, you know how much I esteem and respect you. All of us do.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Ha!” spat Umber. “Respect, you say? Is that what you call what you did?” Umber spun toward Sophie. “Tell me, Sophie: Do I frighten you? Do you think I’m crazy?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No, my lord,” Sophie said in a quaking voice. She covered her mouth with her only hand and turned away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Umber crossed his arms and scowled. “And you, Hap! You know how our fates are intertwined. Are you afraid of me as well, to follow me wherever I go?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hap felt a thousand hot pinpricks across his face. “It’s—it’s not that you frighten me—” he began, before Umber cut him off.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Cowards!” he snapped. “Will none of you speak honestly? Wait a minute—where’s that bloody Oates? Oates, come back here!”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Oates had been quietly edging his way across the deck and down the stairs, trying to escape from sight. His shoulders slumped when he heard his name called, and he trudged back to stand before Umber.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“At least I know "), _c('em', [_vm._v("you’ll")]), _vm._v(" be honest,” Umber said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Don’t do this to me,” Oates muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hap felt sorry for the big fellow. Because of a mysterious curse Oates was compelled to speak the truth at all times. This candor had offended many and earned Oates countless slaps in the face. But because of it Umber knew he could trust Oates completely.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Tell me, Oates: Is that what you think of me? Am I mad? Am I a hazard?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oates sighed. “You’re reckless. You can’t find a beehive without wanting to stick your hand inside. You want to discover things, and you don’t care if you risk our lives along the way. I think one of these days you’ll get one of us killed.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Umber snorted like a bull and stamped a foot on the deck. But then his fierce expression softened. He turned his back to them, staring at the sea. “But … I would never want …” He hung his head till his chin touched his chest. After a moment his shoulders began to bob.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Balfour looked at the others with mournful eyes. He stepped forward and put a hand on Umber’s shoulder. “We ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("know you mean us no harm. But still … that was something to see, wasn’t it? Think of it, Umber: the sea-giants!”")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Umber turned around. He was crying, but not from guilt or despair. The tears flowed past a mouth that had spread into a broad, elated smile. “Amazing! Astonishing! One of the things I wanted to see most in this world, and now I’ve seen it. Weren’t they incredible? Bigger than I ever imagined. Sure, I’d have liked to get closer, but that wasn’t prudent under the circumstances, I’ll grant you that. But I "), _c('em', [_vm._v("saw")]), _vm._v(" them. Sophie, tell me you got a good look! Do you think you can draw them well enough? Should we go back?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No!” cried Sophie, in a tone louder than Hap was accustomed to from her. “I—I saw enough, Lord Umber. I promise.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Wonderful! Wonderful!” Umber shouted, laughing. Behind his back Balfour looked at Hap and shook his head. Hap knew what he was thinking: Umber’s moods shifted so quickly it made a person dizzy.")])]), _c('p', {
    staticClass: "extracts"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f020-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c60927b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 63
// module chunks = 0